import React, { useEffect, useState, useContext } from 'react';
import api from '../utils/api'; 
import './styles/Kidola.css';
import AuthContext from '../context/AuthContext';
import { useNavigate } from 'react-router-dom'; 

const TeacherAttendanceFormPage = () => {
    const { user } = useContext(AuthContext);
    const [attendanceType, setAttendanceType] = useState('');
    const [attendanceDate, setAttendanceDate] = useState('');
    const [attendanceTime, setAttendanceTime] = useState('');
    const [teacher, setTeacher] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        api.post('/teacher/extratime/getTeacher', 
            {
                data: {
                    username: user.username
                }
            })
          .then(response => {
              const teacherData = response.data.data;
              setTeacher(teacherData);
          })
          .catch(error => console.error('Error fetching teacher list:', error));
    }, [user.username]);

    const handleSubmit = () => {

        setErrorMessage('');

        // Validasi input
        if (!attendanceType || !attendanceDate || !attendanceTime) {
            setErrorMessage('Please fill all field!');
            return;
        }

        const confirmation = window.confirm('Are you sure you want to proceed with this action?');
        if (!confirmation) {
            return;
        }

        const attendanceData = {
            attendanceDate: attendanceDate,
            attendanceTime: attendanceTime,
            attendanceType: attendanceType,
            teacher_id: teacher.teacher_id
        };

        const requestBody = { data: { attendanceData } };
        console.log('Request Body:', requestBody);
        api.post('/teacher/attendance/save', requestBody)
            .then(response => {
                const successMessage = response.data.message;
                console.log(successMessage);
                navigate('/success', { state: { message: successMessage } });
            })
            .catch(error => {
                console.error('Error adding/updating teacher:', error);
                navigate('/error', { state: { message: 'Please ask to administrator!' } });
            });
    };

    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Input Attendance</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                    {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>} {/* Tampilkan pesan kesalahan */}
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Teacher Name</label>
                                    </td><td>
                                        <input 
                                            type="text" 
                                            name="teacherName" 
                                            value={teacher.teacher_name} 
                                            readOnly
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Attendance Type</label>
                                    </td>
                                    <td>
                                        <select 
                                            name="type_id" 
                                            value={attendanceType} 
                                            onChange={e => {
                                                setAttendanceType(e.target.value);
                                            }}
                                        >
                                            <option value="">Select Attendance Type</option>
                                            <option value="ARRIVAL">Arrival</option>
                                            <option value="DEPARTURE">Departure</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Attendance Date</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="date" 
                                            name="attendance_date" 
                                            value={attendanceDate} 
                                            onChange={e => setAttendanceDate(e.target.value)} 
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Attendance Time</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="time" 
                                            name="attendance_time" 
                                            value={attendanceTime} 
                                            onChange={e => setAttendanceTime(e.target.value)} 
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> 
                    <div className="search-container">
                        <button onClick={handleSubmit}>Submit</button>
                    </div>
                </div>
            </div>
            
            
        </div>
    );
};

export default TeacherAttendanceFormPage;
